import(/* webpackMode: "eager" */ "/home/ec2-user/ennix-electronics/src/app/out-of-warranty/loading.js");
